import { AxiosResponse } from 'axios';
import Api from './api';

const ContactUsList = (page: number): Promise<AxiosResponse> => {
  const path = `/admin/list/contact-us?page=${page}&per_page=20`;
  return Api.getInstance().request.get(path);
};
export default ContactUsList;
